import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup } from '@angular/forms';
import {
  IncludedCommonFormFieldsInterface,
  MarketplaceApp,
  OrderFormFieldInterface,
} from '@galaxy/marketplace-apps/v1';
import {
  OrderFormFieldOptionsType,
  OrderFormInterface,
  OrderFormOptionsInterface,
  ProductInfoInterface,
} from '../../order-form/order-form/interface';
import { User } from '../../order-form/fields/field-vbcuser';

@Component({
  selector: 'store-form-preview',
  templateUrl: './form-preview.component.html',
  styleUrls: ['./form-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormPreviewDialogComponent implements OnInit {
  form = new UntypedFormGroup({});
  app: MarketplaceApp;
  commonFormRequiredFields: IncludedCommonFormFieldsInterface;
  customFormFields: OrderFormFieldInterface[];
  orderForms: OrderFormInterface[];
  orderFormOptions: OrderFormOptionsInterface;
  productActivationPreReqFormOptions: OrderFormOptionsInterface;
  productInfo: ProductInfoInterface[];
  sampleUserList: User[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<FormPreviewDialogComponent>,
  ) {}

  ngOnInit(): void {
    this.app = this.data.app;
    this.commonFormRequiredFields = this.data.commonFormRequiredFields;
    this.customFormFields = this.data.customFormFields;

    this.productActivationPreReqFormOptions = {
      readOnly: true,
    };

    this.orderFormOptions = {
      bypassRequiredQuestions: false,
      readOnly: false,
      showOfficeUseQuestions: true,
    };

    //predefined sample user list. To be used for previewing "End User" input types.
    this.sampleUserList = [
      {
        userId: 'usr1',
        email: 'user@domain.com',
        firstName: 'Account User',
        lastName: '1',
      },
      {
        userId: 'usr2',
        email: 'user@domain.com',
        firstName: 'Account User',
        lastName: '2',
      },
    ];

    this.prepareOrderFormData();
  }

  prepareOrderFormData(): void {
    this.productInfo = this.buildProductInfo();
    this.orderForms = this.buildOrderForms();
  }

  buildProductInfo(): ProductInfoInterface[] {
    return [
      {
        productId: this.app.appId,
        name: this.app.name,
        tagline: this.app.tagline,
        icon: this.app.icon,
      },
    ];
  }

  buildOrderForms(): OrderFormInterface[] {
    return [
      {
        appId: this.app.appId,
        commonFormRequiredFields: this.commonFormRequiredFields,
        customFields: this.buildCustomOrderFormFields(this.customFormFields),
        footerText: this.app.orderForm?.footerText ? this.app.orderForm?.footerText : null,
      },
    ];
  }

  buildCustomOrderFormFields(orderFormFields: OrderFormFieldInterface[]): OrderFormFieldOptionsType[] {
    return orderFormFields
      .filter((field) => !!field.type)
      .map((f) => ({ ...f, options: f.optionsWithLabels }) as OrderFormFieldOptionsType);
  }

  close(): void {
    this.dialogRef.close();
  }
}
